

























import AppId from '@/util/appid'
import {
  captionsForSignupContext
} from '@spa/components/pages/auth/signup/with-sms/components/note/default/signup-note-for-context'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class PaidMembershipPlanNote extends Vue {
  get caption() {
    return captionsForSignupContext.forPlanApplySignup
  }
  get imageSrc(): string {
    return `/assets-proxy/images/${AppId.getHostName()}/icon-subscription.png`
  }
}
